import { render, staticRenderFns } from "./ProfilePurse.vue?vue&type=template&id=678183b4&scoped=true"
import script from "./ProfilePurse.js?vue&type=script&lang=js&external"
export * from "./ProfilePurse.js?vue&type=script&lang=js&external"
import style0 from "./ProfilePurse.scss?vue&type=style&index=0&id=678183b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678183b4",
  null
  
)

export default component.exports